export const rentalPolicy = "https://www.doorstead.com/statement-of-rental-policy";

export function useFooter() {
  return {
    linkText: "Doorstead Statement of Rental Policy",
    linkUrl: rentalPolicy,
  };
}
